import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import Button from 'components/Button/Button';
import { generateID } from 'utils/helpers';
import iconError from 'images/icon-error.png';

import styles from './TwoFaModal.css';


function PaymentError(props) {
  const { closeModal, errorMsg, ids } = props;

  const btnId = 'cashOutErrorCloseButton';
  const makeId = generateID(ids.prefix, ids.element);

  let translatedErrorMsg = '';
  switch (errorMsg) {
    case 'SOURCE_ACCOUNT_UNAVAILABLE':
      translatedErrorMsg = translate('cam4bucks.cam4bucks.suspended');
      break;
    default:
      translatedErrorMsg = translate('v2profile.notification.error.default');
      break;
  }

  return (
    <Fragment>
      <div className={styles.centredContent}>
        <img
          alt="Error icon"
          className={styles.errorImage}
          src={iconError}
        />
        <h5 className={styles.boldText}>
          {translate('payment.general.error')}
        </h5>
        <p>{translatedErrorMsg}</p>
      </div>
      <div className={`${styles.errorMsgFooter}`}>
        <Button id={makeId(btnId)} onClick={closeModal}>
          {translate('profile.profile.send.message.close')}
        </Button>
      </div>
    </Fragment>
  );
}

PaymentError.propTypes = {
  closeModal: PropTypes.func.isRequired,
  errorMsg: PropTypes.string.isRequired,
  ids: PropTypes.shape({
    element: PropTypes.string.isRequired,
    prefix: PropTypes.string.isRequired,
  }),
};

PaymentError.defaultProps = { ids: {} };

export default PaymentError;
